import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { PropertyId } from "../sdk/Exports";
export var ProxyInfo = /*#__PURE__*/function () {
  function ProxyInfo(proxyHostName, proxyPort, proxyUserName, proxyPassword) {
    _classCallCheck(this, ProxyInfo);

    this.privProxyHostName = proxyHostName;
    this.privProxyPort = proxyPort;
    this.privProxyUserName = proxyUserName;
    this.privProxyPassword = proxyPassword;
  }

  _createClass(ProxyInfo, [{
    key: "HostName",
    get: function get() {
      return this.privProxyHostName;
    }
  }, {
    key: "Port",
    get: function get() {
      return this.privProxyPort;
    }
  }, {
    key: "UserName",
    get: function get() {
      return this.privProxyUserName;
    }
  }, {
    key: "Password",
    get: function get() {
      return this.privProxyPassword;
    }
  }], [{
    key: "fromParameters",
    value: function fromParameters(parameters) {
      return new ProxyInfo(parameters.getProperty(PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(parameters.getProperty(PropertyId.SpeechServiceConnection_ProxyPort), 10), parameters.getProperty(PropertyId.SpeechServiceConnection_ProxyUserName), parameters.getProperty(PropertyId.SpeechServiceConnection_ProxyPassword));
    }
  }, {
    key: "fromRecognizerConfig",
    value: function fromRecognizerConfig(config) {
      return this.fromParameters(config.parameters);
    }
  }]);

  return ProxyInfo;
}();